import React from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';

import { BlogTag } from '@/typings/model';
import Link from '@/components/Link';
import { colors } from '@/constants/theme';

interface Props {
  tags: Array<BlogTag>;
  className?: string;
}

function Tags({ tags, className }: Props) {
  const parentRoute = useRouter().asPath.split('/')[1];

  return (
    <Component className={className}>
      {tags.map(({ tag, urlAlias }, index) => (
        <Tag key={index} to={`/${parentRoute}?tag=${urlAlias}`}>
          {tag}
        </Tag>
      ))}
    </Component>
  );
}

export default Tags;

const Component = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 50px;
  margin-bottom: 20px;

  @media (min-width: 1400px) {
    margin-top: 70px;
  }
`;

const Tag = styled(Link)`
  padding: 15px 30px;
  background: ${colors.gray100};
  border-radius: 6px;
  margin: 5px 5px 5px 0;

  &:hover {
    background: #dee0e3;
  }
`;
